module.exports = __webpack_public_path__ + "static/media/Translations_intro.d577476e.md";